// API Base URL
// - Prefer same-origin in dev to avoid localhost vs 127.0.0.1 CORS issues.
// - You can still override via VITE_APP_URL in .env (e.g. for a remote API).
export const baseUrl = {
  api: (() => {
    const configured = import.meta.env.VITE_APP_URL;
    if (configured && String(configured).trim()) {
      return String(configured).replace(/\/+$/, '') + '/api';
    }
    // Same-origin (works for both http://localhost:8000 and http://127.0.0.1:8000)
    return '/api';
  })(),
};

export const appName = import.meta.env.VITE_APP_NAME;
export const recaptchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
